import React, { useState, useEffect } from 'react';
import { Button, Card, Modal, Table, Pagination, Row, Col, Form, Container } from 'react-bootstrap';
import axios from 'axios';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useHistory } from 'react-router-dom';
import { var_api } from '../../constant';
import Swal from "sweetalert2";

const getFormattedDate = (daysBeforeToday) => {
  const date = new Date();
  date.setDate(date.getDate() - daysBeforeToday);
  return date.toISOString().split('T')[0];
};

const ClientInsight = () => {
  const [clientsSummary, setClientsSummary] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [popupLast30Days, setPopupLast30Days] = useState(false);
  const [startDate, setStartDate] = useState(getFormattedDate(30));
  const [endDate, setEndDate] = useState(getFormattedDate(0));
  const history = useHistory();

  useEffect(() => {
    fetchClientsummary();
  }, [startDate, endDate]);


  const fetchClientsummary = async () => {
    try {
      const token = localStorage.getItem('token');
      // const userId = localStorage.getItem('userId');
      const formattedStartDate = formatToDDMMYY(startDate);
      const formattedEndDate = formatToDDMMYY(endDate);
      const response = await axios.get(
        `${var_api}/api/booking/get-clients-insights/${formattedStartDate}/${formattedEndDate}`,
        { headers: { Authorization: `${token}` } }
      );
      setClientsSummary(response.data);
      setPopupLast30Days(false);
    } catch (error) {
      console.error("Error fetching client summary:", error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    }
  };

  const formatToDDMMYY = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  const filteredClients = clientsSummary.filter((client) => {
    const query = searchQuery.toLowerCase();
    return [
      client.name, client.email_id, client.address_location,
      client.country_name, client.customer_referal, client.membership_no
    ].some(field => field?.toString().toLowerCase().includes(query));
  });

  const totalPages = Math.ceil(filteredClients.length / pageSize);
  const paginatedClients = filteredClients.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const exportToPDF = () => {
    const doc = new jsPDF();
    const columns = [
      "S.No", "Profile", "Name", "Mobile No", "Email", "Location", 
      "Country", "Paid Amount", "Bookings", "Referral", "Membership No", 
      "Service Count", "Membership Points", "Referral Count"
    ];
    const rows = paginatedClients.map((client, index) => [
      index + 1,
      "Image", // For images, text is used as jsPDF requires additional handling for images
      client.name,
      client.mobile_no,
      client.email_id,
      client.address_location,
      client.country_name,
      client.paid_amount,
      client.count_of_booking,
      client.customer_referal,
      client.membership_no,
      client.membership_service_count,
      client.total_membership_points,
      client.total_membership_referal_count
    ]);

    doc.autoTable({
      head: [columns],
      body: rows,
      theme: 'grid'
    });
    doc.save('ClientData.pdf');
  };

  const exportToExcel = () => {
    const data = paginatedClients.map((client, index) => ({
      'S.No': index + 1,
      'Profile': client.profile_image,
      'Client': client.name,
      'Mobile No': client.mobile_no,
      'Email ID': client.email_id,
      'Address Location': client.address_location,
      'Country': client.country_name,
      'Paid Amount': client.paid_amount,
      'Count of Booking': client.count_of_booking,
      'Customer Referral': client.customer_referal,
      'Membership No': client.membership_no,
      'Membership Service Count': client.membership_service_count,
      'Total Membership Points': client.total_membership_points,
      'Total Membership Referral Count': client.total_membership_referal_count
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Clients");
    XLSX.writeFile(wb, 'ClientInsight.xlsx');
  };

  return (
    <Container className="activity-container mx-auto">
          <Button variant="dark" onClick={() => history.push('/reports')} className="mb-4">
            <i className='bx bx-arrow-back'></i> Back
          </Button>
          <h2 className="mb-4 text-center">Client Insight</h2>
          <p className="mb-4 text-center">Overview of new, returning and walk-in clients with appointments in the chosen timeframe.</p>

          <div className="filters mb-4 d-flex justify-content-between">
    <Button variant="dark" onClick={() => setPopupLast30Days(true)}>Date Filter</Button>
    <Form.Control
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search"
            style={{ width: '200px' }} // Adjust width as needed
        />
  </div>

          <Modal show={popupLast30Days} onHide={() => setPopupLast30Days(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Filter Last 30 Days</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="mb-4">
                <Col>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </Col>
                <Col>
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </Col>
              </Row>
              <Button variant="dark" onClick={fetchClientsummary}>Apply</Button>
              <Button variant="outline-secondary" onClick={() => setPopupLast30Days(false)} className="ms-2">Cancel</Button>
            </Modal.Body>
          </Modal>

          {/* <div className="d-flex justify-content-end mb-4">
            <Form.Control
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search"
            />
          </div> */}

          <Table responsive bordered hover>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Profile Image</th>
                <th>Client</th>
                <th>Mobile No</th>
                <th>Email ID</th>
                <th>Address Location</th>
                <th>Country</th>
                <th>Paid Amount</th>
                <th>Count of Booking</th>
                <th>Customer Referral</th>
                <th>Membership No</th>
                <th>Membership Service Count</th>
                <th>Total Membership Points</th>
                <th>Total Membership Referral Count</th>
              </tr>
            </thead>
            <tbody>
              {paginatedClients.length > 0 ? (
                paginatedClients.map((client, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td><img src={`${var_api}/${client.profile_image}`} alt="Profile" className="profile-image" width='65px' height='65px'/></td>
                    <td>{client.name}</td>
                    <td>{client.mobile_no}</td>
                    <td>{client.email_id}</td>
                    <td>{client.address_location}</td>
                    <td>{client.country_name}</td>
                    <td>{client.paid_amount}</td>
                    <td>{client.count_of_booking}</td>
                    <td>{client.customer_referal}</td>
                    <td>{client.membership_no}</td>
                    <td>{client.membership_service_count}</td>
                    <td>{client.total_membership_points}</td>
                    <td>{client.total_membership_referal_count}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="14" className="text-center">No Data Available</td>
                </tr>
              )}
            </tbody>
          </Table>

          <Pagination className="justify-content-center mt-4">
            <Pagination.Prev onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)} disabled={currentPage === 1} />
            {[...Array(totalPages).keys()].map((page) => (
              <Pagination.Item key={page} active={page + 1 === currentPage} onClick={() => setCurrentPage(page + 1)}>
                {page + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages} />
          </Pagination>

          <div className="d-flex justify-content-start mt-3">
            <Button variant="dark" onClick={exportToPDF}>Download as PDF</Button>
            <Button variant="dark" onClick={exportToExcel} className="ms-2">Download as Excel</Button>
          </div>
    </Container>
  );
};

export default ClientInsight;
